import api from './api';

const volunteerService = {
    async getVolunteers() {
        const response = await api.get('/volunteers');
        return response.data;
    },

    async updateStatus(id, status) {
        const response = await api.patch(`/volunteers/${id}/status`, { status });
        return response.data;
    }
};

export default volunteerService;
